/**
 * State used in rendering DrawerFooter
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
